export default __webpack_public_path__ + "static/img-triple-crown-heading-9a6a29ed3bc9d797f0e0b9efb5034a0b.avif";